import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "git-commit",
  "use": "git-commit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"git-commit\">\n<path d=\"M12,17c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S14.8,17,12,17z M12,9c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S13.7,9,12,9z\" />\n<path d=\"M7,13H1.1c-0.6,0-1-0.4-1-1s0.4-1,1-1H7c0.6,0,1,0.4,1,1S7.6,13,7,13z\" />\n<path d=\"M23,13h-6c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1S23.5,13,23,13z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol